export default __webpack_public_path__ + "ecffedb6e73bab614625758434b75e5e.svg";